module.exports = __webpack_public_path__ + "img/logo-dcamp@2x.db70d09c.png";